<template>
  <div class="spin-spotify-playlist-display">
    <expanding-input-with-icon
      icon="spotify"
      :initial="initialHeading"
      :processing="processing"
      placeholder="Paste link to Spotify playlist!"
      @scs-input="submitLink"
    />
    <div class="playlist-window" v-if="playlist">
      <Track
        v-for="(track, index) in playlist.tracks.items"
        :key="index"
        :track="track.track"
      />
    </div>
  </div>
</template>
<script>
import ExpandingInputWithIcon from "../Elements/ExpandingInputWithIcon.vue";
import Track from "./Track.vue";
export default {
  data() {
    return {
      playlist: undefined,
      processing: false,
    };
  },
  computed: {
    initialHeading() {
      if (this.url) {
        if (this.playlist) {
          return this.playlist.name;
        } else {
          if (this.processing) {
            return "Processing";
          } else {
            return "Could not find playlist. Check playlist publicity and try again.";
          }
        }
      }
      return "Click to add Spotify Playlist";
    },
  },
  methods: {
    async submitLink(value) {
      this.$emit("playlist-link-input", value);
      this.processing = true;
      this.playlist = await this.$store.dispatch("getSpotifyPlaylist", value);
      this.processing = false;
    },
  },
  async created() {
    if (this.url) {
      this.processing = true;
      this.playlist = await this.$store.dispatch(
        "getSpotifyPlaylist",
        this.url
      );
      this.processing = false;
    }
  },
  components: {
    ExpandingInputWithIcon,
    Track,
  },
  emits: ["playlist-link-input"],
  props: ["url"],
};
</script>
<style scoped>
@media screen {
  .spin-spotify-playlist-display {
    min-height: 30px;
    padding: 20px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
  }

  .playlist-window {
    padding-top: 10px;
    display: flex;
    flex-wrap: wrap;
    grid-template-columns: 100%;
    grid-auto-rows: auto;
  }

  @media (min-width: 800px) {
    .playlist-window {
      padding-top: 10px;
    }
  }
}
</style>
